// AUTO-GENERATED by scripts/gen-india-locations.js — DO NOT EDIT
// Source: scripts/locationMasterData.js (AP 28 districts, TG 33 districts, 2026-03)

export const MASTER_VERSION = "2026-03";

export const STATES = [
  "Andaman and Nicobar Islands",
  "Andhra Pradesh",
  "Arunachal Pradesh",
  "Assam",
  "Bihar",
  "Chandigarh",
  "Chhattisgarh",
  "Dadra and Nagar Haveli and Daman and Diu",
  "Delhi",
  "Goa",
  "Gujarat",
  "Haryana",
  "Himachal Pradesh",
  "Jammu and Kashmir",
  "Jharkhand",
  "Karnataka",
  "Kerala",
  "Ladakh",
  "Lakshadweep",
  "Madhya Pradesh",
  "Maharashtra",
  "Manipur",
  "Meghalaya",
  "Mizoram",
  "Nagaland",
  "Odisha",
  "Puducherry",
  "Punjab",
  "Rajasthan",
  "Sikkim",
  "Tamil Nadu",
  "Telangana",
  "Tripura",
  "Uttar Pradesh",
  "Uttarakhand",
  "West Bengal"
];

export const DISTRICTS_BY_STATE = {
  "Andhra Pradesh": [
    "Alluri Sitharama Raju",
    "Anakapalli",
    "Anantapur",
    "Annamayya",
    "Bapatla",
    "Chittoor",
    "Dr. B.R. Ambedkar Konaseema",
    "East Godavari",
    "Eluru",
    "Guntur",
    "Kakinada",
    "Krishna",
    "Kurnool",
    "Markapuram",
    "Nandyal",
    "NTR District",
    "Palnadu",
    "Parvathipuram Manyam",
    "Polavaram",
    "Prakasam",
    "Sri Potti Sriramulu Nellore",
    "Sri Sathya Sai",
    "Srikakulam",
    "Tirupati",
    "Visakhapatnam",
    "Vizianagaram",
    "West Godavari",
    "YSR Kadapa"
  ],
  "Telangana": [
    "Adilabad",
    "Bhadradri Kothagudem",
    "Hanumakonda",
    "Hyderabad",
    "Jagtial",
    "Jangaon",
    "Jayashankar Bhupalpally",
    "Jogulamba Gadwal",
    "Kamareddy",
    "Karimnagar",
    "Khammam",
    "Kumuram Bheem Asifabad",
    "Mahabubabad",
    "Mahabubnagar",
    "Mancherial",
    "Medak",
    "Medchal-Malkajgiri",
    "Mulugu",
    "Nagarkurnool",
    "Nalgonda",
    "Narayanpet",
    "Nirmal",
    "Nizamabad",
    "Peddapalli",
    "Rajanna Sircilla",
    "Rangareddy",
    "Sangareddy",
    "Siddipet",
    "Suryapet",
    "Vikarabad",
    "Wanaparthy",
    "Warangal",
    "Yadadri Bhuvanagiri"
  ],
  "Karnataka": [
    "Bagalkot",
    "Ballari",
    "Bangalore Rural",
    "Bangalore Urban",
    "Belagavi",
    "Bidar",
    "Chamarajanagar",
    "Chikkaballapur",
    "Chikkamagaluru",
    "Chitradurga",
    "Dakshina Kannada",
    "Davanagere",
    "Gadag",
    "Hassan",
    "Haveri",
    "Hubballi-Dharwad",
    "Kalaburagi",
    "Kodagu",
    "Kolar",
    "Koppal",
    "Mandya",
    "Mangaluru",
    "Mysuru",
    "Raichur",
    "Ramanagara",
    "Shivamogga",
    "Tumakuru",
    "Udupi",
    "Uttara Kannada",
    "Vijayapura",
    "Yadgir"
  ],
  "Tamil Nadu": [
    "Ariyalur",
    "Chengalpattu",
    "Chennai",
    "Coimbatore",
    "Cuddalore",
    "Dharmapuri",
    "Dindigul",
    "Erode",
    "Kallakurichi",
    "Kanchipuram",
    "Karur",
    "Krishnagiri",
    "Madurai",
    "Mayiladuthurai",
    "Nagapattinam",
    "Namakkal",
    "Nilgiris",
    "Perambalur",
    "Pudukkottai",
    "Ramanathapuram",
    "Ranipet",
    "Salem",
    "Sivaganga",
    "Tenkasi",
    "Thanjavur",
    "Theni",
    "Thoothukudi",
    "Tiruchirappalli",
    "Tirunelveli",
    "Tirupattur",
    "Tiruppur",
    "Tiruvallur",
    "Vellore",
    "Virudhunagar"
  ],
  "Maharashtra": [
    "Ahmednagar",
    "Akola",
    "Amravati",
    "Aurangabad",
    "Beed",
    "Bhandara",
    "Buldhana",
    "Chandrapur",
    "Dhule",
    "Gadchiroli",
    "Gondia",
    "Hingoli",
    "Jalgaon",
    "Jalna",
    "Kolhapur",
    "Latur",
    "Mumbai",
    "Nagpur",
    "Nanded",
    "Nandurbar",
    "Nashik",
    "Osmanabad",
    "Palghar",
    "Parbhani",
    "Pune",
    "Raigad",
    "Ratnagiri",
    "Sangli",
    "Satara",
    "Sindhudurg",
    "Solapur",
    "Thane",
    "Wardha",
    "Washim",
    "Yavatmal"
  ],
  "Kerala": [
    "Alappuzha",
    "Ernakulam",
    "Idukki",
    "Kannur",
    "Kasaragod",
    "Kollam",
    "Kottayam",
    "Kozhikode",
    "Malappuram",
    "Palakkad",
    "Pathanamthitta",
    "Thiruvananthapuram",
    "Thrissur",
    "Wayanad"
  ],
  "Delhi": [
    "Central Delhi",
    "East Delhi",
    "New Delhi",
    "North Delhi",
    "North East Delhi",
    "North West Delhi",
    "Shahdara",
    "South Delhi",
    "South East Delhi",
    "South West Delhi",
    "West Delhi"
  ],
  "Odisha": [
    "Balasore",
    "Cuttack",
    "Ganjam",
    "Jajpur",
    "Khordha",
    "Koraput",
    "Mayurbhanj",
    "Puri",
    "Sambalpur",
    "Sundargarh"
  ],
  "West Bengal": [
    "Bardhaman",
    "Darjeeling",
    "Hooghly",
    "Howrah",
    "Kolkata",
    "Murshidabad",
    "Nadia",
    "North 24 Parganas",
    "Siliguri",
    "South 24 Parganas"
  ],
  "Rajasthan": [
    "Ajmer",
    "Alwar",
    "Bharatpur",
    "Bikaner",
    "Jaipur",
    "Jodhpur",
    "Kota",
    "Pali",
    "Sikar",
    "Udaipur"
  ],
  "Gujarat": [
    "Ahmedabad",
    "Anand",
    "Bhavnagar",
    "Gandhinagar",
    "Jamnagar",
    "Kheda",
    "Mehsana",
    "Rajkot",
    "Surat",
    "Vadodara"
  ],
  "Punjab": [
    "Amritsar",
    "Bathinda",
    "Gurdaspur",
    "Hoshiarpur",
    "Jalandhar",
    "Ludhiana",
    "Mohali",
    "Patiala"
  ],
  "Uttar Pradesh": [
    "Agra",
    "Bareilly",
    "Ghaziabad",
    "Gorakhpur",
    "Kanpur",
    "Lucknow",
    "Meerut",
    "Noida",
    "Prayagraj",
    "Varanasi"
  ],
  "Madhya Pradesh": [
    "Bhopal",
    "Gwalior",
    "Indore",
    "Jabalpur",
    "Rewa",
    "Sagar",
    "Satna",
    "Ujjain"
  ],
  "Bihar": [
    "Bhagalpur",
    "Darbhanga",
    "Gaya",
    "Muzaffarpur",
    "Patna",
    "Purnia"
  ],
  "Jharkhand": [
    "Bokaro",
    "Deoghar",
    "Dhanbad",
    "Jamshedpur",
    "Ranchi"
  ],
  "Chhattisgarh": [
    "Bilaspur",
    "Durg",
    "Korba",
    "Raigarh",
    "Raipur"
  ],
  "Goa": [
    "North Goa",
    "South Goa"
  ],
  "Assam": [
    "Dibrugarh",
    "Jorhat",
    "Kamrup Metropolitan",
    "Silchar",
    "Tezpur"
  ],
  "Puducherry": [
    "Karaikal",
    "Mahe",
    "Puducherry",
    "Yanam"
  ],
  "Andaman and Nicobar Islands": [
    "General"
  ],
  "Arunachal Pradesh": [
    "General"
  ],
  "Chandigarh": [
    "General"
  ],
  "Dadra and Nagar Haveli and Daman and Diu": [
    "General"
  ],
  "Haryana": [
    "General"
  ],
  "Himachal Pradesh": [
    "General"
  ],
  "Jammu and Kashmir": [
    "General"
  ],
  "Ladakh": [
    "General"
  ],
  "Lakshadweep": [
    "General"
  ],
  "Manipur": [
    "General"
  ],
  "Meghalaya": [
    "General"
  ],
  "Mizoram": [
    "General"
  ],
  "Nagaland": [
    "General"
  ],
  "Sikkim": [
    "General"
  ],
  "Tripura": [
    "General"
  ],
  "Uttarakhand": [
    "General"
  ]
};

export const MANDALS_BY_STATE_DISTRICT = {
  "Andhra Pradesh|Alluri Sitharama Raju": [
    "Paderu",
    "Araku Valley",
    "Ananthagiri",
    "Chintapalle",
    "G.Madugula",
    "Hukumpeta",
    "Koyyuru",
    "Munchingiput",
    "Pedabayalu",
    "Dumbriguda"
  ],
  "Andhra Pradesh|Anakapalli": [
    "Anakapalli",
    "Chodavaram",
    "Narsipatnam",
    "Yelamanchili",
    "Payakaraopeta",
    "Madugula",
    "Devarapalle",
    "Kasimkota",
    "S.Rayavaram",
    "Rambilli"
  ],
  "Andhra Pradesh|Annamayya": [
    "Rayachoti",
    "Rajampet",
    "Kamalapuram",
    "Lakkireddipalle",
    "Chinnamandem",
    "Galiveedu",
    "Sambepalle",
    "Ramapuram",
    "Chitvel",
    "Pullampeta"
  ],
  "Andhra Pradesh|Anantapur": [
    "Anantapur",
    "Dharmavaram",
    "Hindupur",
    "Kadiri",
    "Kalyanadurgam",
    "Guntakal",
    "Tadipatri",
    "Penukonda",
    "Rayadurg",
    "Gooty",
    "Uravakonda",
    "Pamidi"
  ],
  "Andhra Pradesh|Bapatla": [
    "Bapatla",
    "Chirala",
    "Repalle",
    "Addanki",
    "Karlapalem",
    "Parchur",
    "Inkollu",
    "Martur",
    "Nizampatnam"
  ],
  "Andhra Pradesh|Chittoor": [
    "Chittoor",
    "Madanapalle",
    "Punganur",
    "Palamaner",
    "Pileru",
    "Nagari",
    "Kuppam",
    "Gudipala",
    "Palasamudram",
    "Vayalpad",
    "Irala",
    "Puthalapattu",
    "Baireddipalle",
    "Bangarupalem",
    "Buchinaidu Khandriga",
    "Chinnagottigallu",
    "Gangadhara Nellore",
    "Gudupalle",
    "Kalikiri",
    "Karvetinagaram",
    "Kothapalle",
    "Mulakalacheruvu",
    "Nindra",
    "Peddamandyam",
    "Peddapanjani",
    "Penumur",
    "Pichatur",
    "Ramasamudram",
    "Rompicharla",
    "Santhipuram",
    "Sodam",
    "Somala",
    "Thamballapalle",
    "Tavanampalle",
    "Vedurukuppam",
    "Yadamarri"
  ],
  "Andhra Pradesh|Dr. B.R. Ambedkar Konaseema": [
    "Amalapuram",
    "Ramachandrapuram",
    "Mummidivaram",
    "Razole",
    "Kothapeta",
    "Allavaram",
    "Ambajipeta",
    "Atreyapuram",
    "I.Polavaram",
    "Malikipuram"
  ],
  "Andhra Pradesh|East Godavari": [
    "Kakinada",
    "Rajahmundry",
    "Samalkot",
    "Peddapuram",
    "Tuni",
    "Mandapeta",
    "Pithapuram",
    "Gollaprolu",
    "Rampachodavaram",
    "Yeleswaram",
    "Anaparthi"
  ],
  "Andhra Pradesh|Eluru": [
    "Eluru",
    "Bhimavaram",
    "Tadepalligudem",
    "Tanuku",
    "Nuzvid",
    "Kaikaluru",
    "Nidadavole",
    "Kovvur",
    "Chintalapudi",
    "Denduluru",
    "Pedavegi"
  ],
  "Andhra Pradesh|Guntur": [
    "Guntur",
    "Tenali",
    "Mangalagiri",
    "Tadepalle",
    "Thullur",
    "Amaravathi",
    "Duggirala",
    "Pedakakani",
    "Tadikonda",
    "Chebrolu",
    "Kakumanu",
    "Ponnur"
  ],
  "Andhra Pradesh|Kakinada": [
    "Kakinada",
    "Peddapuram",
    "Samalkot",
    "Tuni",
    "Pithapuram",
    "Gollaprolu",
    "Jaggampeta",
    "Kirlampudi",
    "Prathipadu",
    "Sankhavaram"
  ],
  "Andhra Pradesh|Krishna": [
    "Machilipatnam",
    "Gudivada",
    "Nuzvid",
    "Avanigadda",
    "Bantumilli",
    "Kaikaluru",
    "Movva",
    "Pedana",
    "Pamarru",
    "Ghantasala",
    "Guduru"
  ],
  "Andhra Pradesh|Kurnool": [
    "Kurnool",
    "Adoni",
    "Yemmiganur",
    "Dhone",
    "Atmakur",
    "Nandikotkur",
    "Allagadda",
    "Banaganapalle",
    "Kodumur",
    "Orvakal",
    "Pattikonda"
  ],
  "Andhra Pradesh|Markapuram": [
    "Markapur",
    "Kanigiri",
    "Dornala",
    "Giddalur",
    "Cumbum",
    "Konakanamitla",
    "Podili",
    "Yerragondapalem",
    "Pullalacheruvu",
    "Tripuranthakam"
  ],
  "Andhra Pradesh|Nandyal": [
    "Nandyal",
    "Allagadda",
    "Banaganapalle",
    "Bethamcherla",
    "Dhone",
    "Koilkuntla",
    "Mahanandi",
    "Owk",
    "Sanjamala",
    "Velugodu"
  ],
  "Andhra Pradesh|NTR District": [
    "Vijayawada",
    "Gannavaram",
    "Ibrahimpatnam",
    "Penamaluru",
    "Nandigama",
    "Jaggayyapeta",
    "Tiruvuru",
    "Mylavaram",
    "Vuyyuru",
    "Reddigudem"
  ],
  "Andhra Pradesh|Palnadu": [
    "Narasaraopet",
    "Sattenapalli",
    "Macherla",
    "Piduguralla",
    "Gurazala",
    "Vinukonda",
    "Dachepalle",
    "Bollapalle",
    "Muppalla",
    "Nekarikallu"
  ],
  "Andhra Pradesh|Parvathipuram Manyam": [
    "Parvathipuram",
    "Palakonda",
    "Seethanagaram",
    "Garugubilli",
    "Komarada",
    "Kurupam",
    "Makkuva",
    "Pachipenta",
    "Salur"
  ],
  "Andhra Pradesh|Polavaram": [
    "Rampachodavaram",
    "Chinturu",
    "Kunavaram",
    "Maredumilli",
    "Devipatnam",
    "Y.Ramavaram",
    "Addateegala",
    "Gangavaram",
    "Rajavommangi",
    "Vararamachandrapuram"
  ],
  "Andhra Pradesh|Prakasam": [
    "Ongole",
    "Chirala",
    "Kandukur",
    "Darsi",
    "Podili",
    "Giddalur",
    "Cumbum",
    "Markapur",
    "Kanigiri",
    "Pamur",
    "Parchur",
    "Singarayakonda",
    "Tanguturu"
  ],
  "Andhra Pradesh|Sri Potti Sriramulu Nellore": [
    "Nellore",
    "Kavali",
    "Gudur",
    "Kota",
    "Chillakur",
    "Atmakur",
    "Kovur",
    "Kodavalur",
    "Allur",
    "Buchireddipalem",
    "Indukurpet",
    "Venkatagiri",
    "Sullurpeta",
    "Tada",
    "Manubolu",
    "Muthukur",
    "Vidavalur",
    "Vinjamur"
  ],
  "Andhra Pradesh|Sri Sathya Sai": [
    "Puttaparthi",
    "Dharmavaram",
    "Hindupur",
    "Kadiri",
    "Madakasira",
    "Penukonda",
    "Gorantla",
    "Kothacheruvu",
    "Nallamada",
    "Parigi"
  ],
  "Andhra Pradesh|Srikakulam": [
    "Srikakulam",
    "Palasa",
    "Tekkali",
    "Amadalavalasa",
    "Ichchapuram",
    "Rajam",
    "Narasannapeta",
    "Palakonda",
    "Pathapatnam",
    "Sompeta"
  ],
  "Andhra Pradesh|Tirupati": [
    "Tirupati",
    "Renigunta",
    "Chandragiri",
    "Ramachandrapuram",
    "Puttur",
    "Pakala",
    "Srikalahasti",
    "Yerpedu",
    "Narayanavanam",
    "Vadamalapeta",
    "Thottambedu",
    "Sullurupeta",
    "Naidupeta",
    "Tada",
    "Satyavedu",
    "Varadaiahpalem",
    "Venkatagiri",
    "Chitvel",
    "Pullampeta",
    "Obulavaripalle",
    "Penagalur",
    "Railway Koduru",
    "Gudimallam",
    "Korlagunta",
    "Renigunta Rural",
    "Tirupati Rural"
  ],
  "Andhra Pradesh|Visakhapatnam": [
    "Visakhapatnam",
    "Gajuwaka",
    "Pendurthi",
    "Bheemunipatnam",
    "Anandapuram",
    "Padmanabham",
    "Paravada",
    "Sabbavaram"
  ],
  "Andhra Pradesh|Vizianagaram": [
    "Vizianagaram",
    "Bobbili",
    "Parvathipuram",
    "Salur",
    "Nellimarla",
    "Cheepurupalli",
    "Gajapathinagaram",
    "Srungavarapukota"
  ],
  "Andhra Pradesh|West Godavari": [
    "Bhimavaram",
    "Palakollu",
    "Narasapuram",
    "Tadepalligudem",
    "Tanuku",
    "Jangareddygudem",
    "Kovvur",
    "Nidadavole",
    "Undi",
    "Penugonda"
  ],
  "Andhra Pradesh|YSR Kadapa": [
    "Kadapa",
    "Proddatur",
    "Jammalamadugu",
    "Pulivendla",
    "Mydukur",
    "Badvel",
    "Kamalapuram",
    "Pendlimarri",
    "Porumamilla",
    "Sidhout",
    "Vempalle"
  ],
  "Telangana|Adilabad": [
    "Adilabad",
    "Boath",
    "Ichoda",
    "Jainoor",
    "Narnoor",
    "Utnoor"
  ],
  "Telangana|Bhadradri Kothagudem": [
    "Bhadradri Kothagudem",
    "Other Area"
  ],
  "Telangana|Hanumakonda": [
    "Hanamkonda",
    "Kazipet",
    "Hasanparthy",
    "Inavole",
    "Velair",
    "Dharmasagar"
  ],
  "Telangana|Hyderabad": [
    "Amberpet",
    "Ameerpet",
    "Asifnagar",
    "Bahadurpura",
    "Bandlaguda",
    "Charminar",
    "Golconda",
    "Himayathnagar",
    "Khairatabad",
    "Malakpet",
    "Marredpally",
    "Musheerabad",
    "Nampally",
    "Secunderabad",
    "Shaikpet",
    "Tirumalgiri"
  ],
  "Telangana|Jagtial": [
    "Jagtial",
    "Other Area"
  ],
  "Telangana|Jangaon": [
    "Jangaon",
    "Other Area"
  ],
  "Telangana|Jayashankar Bhupalpally": [
    "Jayashankar Bhupalpally",
    "Other Area"
  ],
  "Telangana|Jogulamba Gadwal": [
    "Jogulamba Gadwal",
    "Other Area"
  ],
  "Telangana|Kamareddy": [
    "Kamareddy",
    "Other Area"
  ],
  "Telangana|Karimnagar": [
    "Karimnagar",
    "Huzurabad",
    "Jammikunta",
    "Choppadandi",
    "Saidapur",
    "Manakondur"
  ],
  "Telangana|Khammam": [
    "Khammam",
    "Kallur",
    "Mudigonda",
    "Nelakondapalle",
    "Sathupally",
    "Wyra"
  ],
  "Telangana|Kumuram Bheem Asifabad": [
    "Kumuram Bheem Asifabad",
    "Other Area"
  ],
  "Telangana|Mahabubabad": [
    "Mahabubabad",
    "Other Area"
  ],
  "Telangana|Mahabubnagar": [
    "Mahabubnagar",
    "Gadwal",
    "Wanaparthy",
    "Kollapur",
    "Kodangal",
    "Narayanpet"
  ],
  "Telangana|Mancherial": [
    "Mancherial",
    "Other Area"
  ],
  "Telangana|Medak": [
    "Medak",
    "Narsapur",
    "Ramayampet",
    "Shankarampet",
    "Tekmal",
    "Toopran"
  ],
  "Telangana|Medchal-Malkajgiri": [
    "Malkajgiri",
    "Medchal",
    "Quthbullapur",
    "Keesara",
    "Ghatkesar",
    "Uppal",
    "Kapra",
    "Alwal",
    "Bachupally",
    "Balanagar"
  ],
  "Telangana|Mulugu": [
    "Mulugu",
    "Other Area"
  ],
  "Telangana|Nagarkurnool": [
    "Nagarkurnool",
    "Other Area"
  ],
  "Telangana|Nalgonda": [
    "Nalgonda",
    "Miryalaguda",
    "Devarakonda",
    "Nakrekal",
    "Chityala",
    "Nidamanur"
  ],
  "Telangana|Narayanpet": [
    "Narayanpet",
    "Other Area"
  ],
  "Telangana|Nirmal": [
    "Nirmal",
    "Other Area"
  ],
  "Telangana|Nizamabad": [
    "Nizamabad",
    "Armoor",
    "Balkonda",
    "Bheemgal",
    "Dichpalle",
    "Jakranpalle"
  ],
  "Telangana|Peddapalli": [
    "Peddapalli",
    "Other Area"
  ],
  "Telangana|Rajanna Sircilla": [
    "Rajanna Sircilla",
    "Other Area"
  ],
  "Telangana|Rangareddy": [
    "Rajendranagar",
    "Serilingampally",
    "Shamshabad",
    "Ibrahimpatnam",
    "Maheshwaram",
    "Chevella",
    "Shankarpalle",
    "Moinabad",
    "Shabad",
    "Kandukur",
    "Yacharam"
  ],
  "Telangana|Sangareddy": [
    "Sangareddy",
    "Patancheru",
    "Jinnaram",
    "Kondapur",
    "Ramachandrapuram",
    "Sadasivpet"
  ],
  "Telangana|Siddipet": [
    "Siddipet",
    "Gajwel",
    "Husnabad",
    "Dubbak",
    "Chinnakodur",
    "Komuravelli"
  ],
  "Telangana|Suryapet": [
    "Suryapet",
    "Other Area"
  ],
  "Telangana|Vikarabad": [
    "Vikarabad",
    "Other Area"
  ],
  "Telangana|Wanaparthy": [
    "Wanaparthy",
    "Other Area"
  ],
  "Telangana|Warangal": [
    "Warangal",
    "Hanamkonda",
    "Kazipet",
    "Parkal",
    "Wardhannapet",
    "Narsampet",
    "Eturnagaram",
    "Mogullapalle",
    "Duggondi",
    "Nallabelly"
  ],
  "Telangana|Yadadri Bhuvanagiri": [
    "Yadadri Bhuvanagiri",
    "Other Area"
  ],
  "Karnataka|Bangalore Urban": [
    "Bangalore Urban",
    "Other Area"
  ],
  "Karnataka|Bangalore Rural": [
    "Bangalore Rural",
    "Other Area"
  ],
  "Karnataka|Mysuru": [
    "Mysuru",
    "Other Area"
  ],
  "Karnataka|Belagavi": [
    "Belagavi",
    "Other Area"
  ],
  "Karnataka|Mangaluru": [
    "Mangaluru",
    "Other Area"
  ],
  "Karnataka|Hubballi-Dharwad": [
    "Hubballi-Dharwad",
    "Other Area"
  ],
  "Karnataka|Kalaburagi": [
    "Kalaburagi",
    "Other Area"
  ],
  "Karnataka|Ballari": [
    "Ballari",
    "Other Area"
  ],
  "Karnataka|Tumakuru": [
    "Tumakuru",
    "Other Area"
  ],
  "Karnataka|Davanagere": [
    "Davanagere",
    "Other Area"
  ],
  "Karnataka|Shivamogga": [
    "Shivamogga",
    "Other Area"
  ],
  "Karnataka|Hassan": [
    "Hassan",
    "Other Area"
  ],
  "Karnataka|Mandya": [
    "Mandya",
    "Other Area"
  ],
  "Karnataka|Kolar": [
    "Kolar",
    "Other Area"
  ],
  "Karnataka|Chikkamagaluru": [
    "Chikkamagaluru",
    "Other Area"
  ],
  "Karnataka|Udupi": [
    "Udupi",
    "Other Area"
  ],
  "Karnataka|Dakshina Kannada": [
    "Dakshina Kannada",
    "Other Area"
  ],
  "Karnataka|Uttara Kannada": [
    "Uttara Kannada",
    "Other Area"
  ],
  "Karnataka|Raichur": [
    "Raichur",
    "Other Area"
  ],
  "Karnataka|Bidar": [
    "Bidar",
    "Other Area"
  ],
  "Karnataka|Bagalkot": [
    "Bagalkot",
    "Other Area"
  ],
  "Karnataka|Vijayapura": [
    "Vijayapura",
    "Other Area"
  ],
  "Karnataka|Haveri": [
    "Haveri",
    "Other Area"
  ],
  "Karnataka|Chitradurga": [
    "Chitradurga",
    "Other Area"
  ],
  "Karnataka|Koppal": [
    "Koppal",
    "Other Area"
  ],
  "Karnataka|Yadgir": [
    "Yadgir",
    "Other Area"
  ],
  "Karnataka|Ramanagara": [
    "Ramanagara",
    "Other Area"
  ],
  "Karnataka|Chikkaballapur": [
    "Chikkaballapur",
    "Other Area"
  ],
  "Karnataka|Kodagu": [
    "Kodagu",
    "Other Area"
  ],
  "Karnataka|Gadag": [
    "Gadag",
    "Other Area"
  ],
  "Karnataka|Chamarajanagar": [
    "Chamarajanagar",
    "Other Area"
  ],
  "Tamil Nadu|Chennai": [
    "Chennai",
    "Other Area"
  ],
  "Tamil Nadu|Coimbatore": [
    "Coimbatore",
    "Other Area"
  ],
  "Tamil Nadu|Madurai": [
    "Madurai",
    "Other Area"
  ],
  "Tamil Nadu|Tiruchirappalli": [
    "Tiruchirappalli",
    "Other Area"
  ],
  "Tamil Nadu|Salem": [
    "Salem",
    "Other Area"
  ],
  "Tamil Nadu|Tirunelveli": [
    "Tirunelveli",
    "Other Area"
  ],
  "Tamil Nadu|Tiruppur": [
    "Tiruppur",
    "Other Area"
  ],
  "Tamil Nadu|Erode": [
    "Erode",
    "Other Area"
  ],
  "Tamil Nadu|Vellore": [
    "Vellore",
    "Other Area"
  ],
  "Tamil Nadu|Thoothukudi": [
    "Thoothukudi",
    "Other Area"
  ],
  "Tamil Nadu|Dindigul": [
    "Dindigul",
    "Other Area"
  ],
  "Tamil Nadu|Thanjavur": [
    "Thanjavur",
    "Other Area"
  ],
  "Tamil Nadu|Kanchipuram": [
    "Kanchipuram",
    "Other Area"
  ],
  "Tamil Nadu|Chengalpattu": [
    "Chengalpattu",
    "Other Area"
  ],
  "Tamil Nadu|Tiruvallur": [
    "Tiruvallur",
    "Other Area"
  ],
  "Tamil Nadu|Cuddalore": [
    "Cuddalore",
    "Other Area"
  ],
  "Tamil Nadu|Nagapattinam": [
    "Nagapattinam",
    "Other Area"
  ],
  "Tamil Nadu|Krishnagiri": [
    "Krishnagiri",
    "Other Area"
  ],
  "Tamil Nadu|Dharmapuri": [
    "Dharmapuri",
    "Other Area"
  ],
  "Tamil Nadu|Namakkal": [
    "Namakkal",
    "Other Area"
  ],
  "Tamil Nadu|Karur": [
    "Karur",
    "Other Area"
  ],
  "Tamil Nadu|Sivaganga": [
    "Sivaganga",
    "Other Area"
  ],
  "Tamil Nadu|Ramanathapuram": [
    "Ramanathapuram",
    "Other Area"
  ],
  "Tamil Nadu|Virudhunagar": [
    "Virudhunagar",
    "Other Area"
  ],
  "Tamil Nadu|Tenkasi": [
    "Tenkasi",
    "Other Area"
  ],
  "Tamil Nadu|Kallakurichi": [
    "Kallakurichi",
    "Other Area"
  ],
  "Tamil Nadu|Ranipet": [
    "Ranipet",
    "Other Area"
  ],
  "Tamil Nadu|Tirupattur": [
    "Tirupattur",
    "Other Area"
  ],
  "Tamil Nadu|Mayiladuthurai": [
    "Mayiladuthurai",
    "Other Area"
  ],
  "Tamil Nadu|Ariyalur": [
    "Ariyalur",
    "Other Area"
  ],
  "Tamil Nadu|Perambalur": [
    "Perambalur",
    "Other Area"
  ],
  "Tamil Nadu|Pudukkottai": [
    "Pudukkottai",
    "Other Area"
  ],
  "Tamil Nadu|Nilgiris": [
    "Nilgiris",
    "Other Area"
  ],
  "Tamil Nadu|Theni": [
    "Theni",
    "Other Area"
  ],
  "Maharashtra|Mumbai": [
    "Mumbai",
    "Other Area"
  ],
  "Maharashtra|Pune": [
    "Pune",
    "Other Area"
  ],
  "Maharashtra|Nagpur": [
    "Nagpur",
    "Other Area"
  ],
  "Maharashtra|Thane": [
    "Thane",
    "Other Area"
  ],
  "Maharashtra|Nashik": [
    "Nashik",
    "Other Area"
  ],
  "Maharashtra|Aurangabad": [
    "Aurangabad",
    "Other Area"
  ],
  "Maharashtra|Solapur": [
    "Solapur",
    "Other Area"
  ],
  "Maharashtra|Kolhapur": [
    "Kolhapur",
    "Other Area"
  ],
  "Maharashtra|Satara": [
    "Satara",
    "Other Area"
  ],
  "Maharashtra|Sangli": [
    "Sangli",
    "Other Area"
  ],
  "Maharashtra|Ahmednagar": [
    "Ahmednagar",
    "Other Area"
  ],
  "Maharashtra|Jalgaon": [
    "Jalgaon",
    "Other Area"
  ],
  "Maharashtra|Akola": [
    "Akola",
    "Other Area"
  ],
  "Maharashtra|Amravati": [
    "Amravati",
    "Other Area"
  ],
  "Maharashtra|Nanded": [
    "Nanded",
    "Other Area"
  ],
  "Maharashtra|Latur": [
    "Latur",
    "Other Area"
  ],
  "Maharashtra|Osmanabad": [
    "Osmanabad",
    "Other Area"
  ],
  "Maharashtra|Beed": [
    "Beed",
    "Other Area"
  ],
  "Maharashtra|Parbhani": [
    "Parbhani",
    "Other Area"
  ],
  "Maharashtra|Hingoli": [
    "Hingoli",
    "Other Area"
  ],
  "Maharashtra|Washim": [
    "Washim",
    "Other Area"
  ],
  "Maharashtra|Buldhana": [
    "Buldhana",
    "Other Area"
  ],
  "Maharashtra|Yavatmal": [
    "Yavatmal",
    "Other Area"
  ],
  "Maharashtra|Wardha": [
    "Wardha",
    "Other Area"
  ],
  "Maharashtra|Chandrapur": [
    "Chandrapur",
    "Other Area"
  ],
  "Maharashtra|Gadchiroli": [
    "Gadchiroli",
    "Other Area"
  ],
  "Maharashtra|Gondia": [
    "Gondia",
    "Other Area"
  ],
  "Maharashtra|Bhandara": [
    "Bhandara",
    "Other Area"
  ],
  "Maharashtra|Raigad": [
    "Raigad",
    "Other Area"
  ],
  "Maharashtra|Ratnagiri": [
    "Ratnagiri",
    "Other Area"
  ],
  "Maharashtra|Sindhudurg": [
    "Sindhudurg",
    "Other Area"
  ],
  "Maharashtra|Palghar": [
    "Palghar",
    "Other Area"
  ],
  "Maharashtra|Dhule": [
    "Dhule",
    "Other Area"
  ],
  "Maharashtra|Nandurbar": [
    "Nandurbar",
    "Other Area"
  ],
  "Maharashtra|Jalna": [
    "Jalna",
    "Other Area"
  ],
  "Kerala|Thiruvananthapuram": [
    "Thiruvananthapuram",
    "Other Area"
  ],
  "Kerala|Kollam": [
    "Kollam",
    "Other Area"
  ],
  "Kerala|Pathanamthitta": [
    "Pathanamthitta",
    "Other Area"
  ],
  "Kerala|Alappuzha": [
    "Alappuzha",
    "Other Area"
  ],
  "Kerala|Kottayam": [
    "Kottayam",
    "Other Area"
  ],
  "Kerala|Idukki": [
    "Idukki",
    "Other Area"
  ],
  "Kerala|Ernakulam": [
    "Ernakulam",
    "Other Area"
  ],
  "Kerala|Thrissur": [
    "Thrissur",
    "Other Area"
  ],
  "Kerala|Palakkad": [
    "Palakkad",
    "Other Area"
  ],
  "Kerala|Malappuram": [
    "Malappuram",
    "Other Area"
  ],
  "Kerala|Kozhikode": [
    "Kozhikode",
    "Other Area"
  ],
  "Kerala|Wayanad": [
    "Wayanad",
    "Other Area"
  ],
  "Kerala|Kannur": [
    "Kannur",
    "Other Area"
  ],
  "Kerala|Kasaragod": [
    "Kasaragod",
    "Other Area"
  ],
  "Delhi|Central Delhi": [
    "Central Delhi",
    "Other Area"
  ],
  "Delhi|North Delhi": [
    "North Delhi",
    "Other Area"
  ],
  "Delhi|South Delhi": [
    "South Delhi",
    "Other Area"
  ],
  "Delhi|East Delhi": [
    "East Delhi",
    "Other Area"
  ],
  "Delhi|West Delhi": [
    "West Delhi",
    "Other Area"
  ],
  "Delhi|New Delhi": [
    "New Delhi",
    "Other Area"
  ],
  "Delhi|North East Delhi": [
    "North East Delhi",
    "Other Area"
  ],
  "Delhi|North West Delhi": [
    "North West Delhi",
    "Other Area"
  ],
  "Delhi|South East Delhi": [
    "South East Delhi",
    "Other Area"
  ],
  "Delhi|South West Delhi": [
    "South West Delhi",
    "Other Area"
  ],
  "Delhi|Shahdara": [
    "Shahdara",
    "Other Area"
  ],
  "Odisha|Khordha": [
    "Khordha",
    "Other Area"
  ],
  "Odisha|Cuttack": [
    "Cuttack",
    "Other Area"
  ],
  "Odisha|Puri": [
    "Puri",
    "Other Area"
  ],
  "Odisha|Ganjam": [
    "Ganjam",
    "Other Area"
  ],
  "Odisha|Sambalpur": [
    "Sambalpur",
    "Other Area"
  ],
  "Odisha|Balasore": [
    "Balasore",
    "Other Area"
  ],
  "Odisha|Mayurbhanj": [
    "Mayurbhanj",
    "Other Area"
  ],
  "Odisha|Koraput": [
    "Koraput",
    "Other Area"
  ],
  "Odisha|Sundargarh": [
    "Sundargarh",
    "Other Area"
  ],
  "Odisha|Jajpur": [
    "Jajpur",
    "Other Area"
  ],
  "West Bengal|Kolkata": [
    "Kolkata",
    "Other Area"
  ],
  "West Bengal|North 24 Parganas": [
    "North 24 Parganas",
    "Other Area"
  ],
  "West Bengal|South 24 Parganas": [
    "South 24 Parganas",
    "Other Area"
  ],
  "West Bengal|Howrah": [
    "Howrah",
    "Other Area"
  ],
  "West Bengal|Hooghly": [
    "Hooghly",
    "Other Area"
  ],
  "West Bengal|Nadia": [
    "Nadia",
    "Other Area"
  ],
  "West Bengal|Murshidabad": [
    "Murshidabad",
    "Other Area"
  ],
  "West Bengal|Darjeeling": [
    "Darjeeling",
    "Other Area"
  ],
  "West Bengal|Siliguri": [
    "Siliguri",
    "Other Area"
  ],
  "West Bengal|Bardhaman": [
    "Bardhaman",
    "Other Area"
  ],
  "Rajasthan|Jaipur": [
    "Jaipur",
    "Other Area"
  ],
  "Rajasthan|Jodhpur": [
    "Jodhpur",
    "Other Area"
  ],
  "Rajasthan|Udaipur": [
    "Udaipur",
    "Other Area"
  ],
  "Rajasthan|Kota": [
    "Kota",
    "Other Area"
  ],
  "Rajasthan|Ajmer": [
    "Ajmer",
    "Other Area"
  ],
  "Rajasthan|Bikaner": [
    "Bikaner",
    "Other Area"
  ],
  "Rajasthan|Alwar": [
    "Alwar",
    "Other Area"
  ],
  "Rajasthan|Bharatpur": [
    "Bharatpur",
    "Other Area"
  ],
  "Rajasthan|Sikar": [
    "Sikar",
    "Other Area"
  ],
  "Rajasthan|Pali": [
    "Pali",
    "Other Area"
  ],
  "Gujarat|Ahmedabad": [
    "Ahmedabad",
    "Other Area"
  ],
  "Gujarat|Surat": [
    "Surat",
    "Other Area"
  ],
  "Gujarat|Vadodara": [
    "Vadodara",
    "Other Area"
  ],
  "Gujarat|Rajkot": [
    "Rajkot",
    "Other Area"
  ],
  "Gujarat|Bhavnagar": [
    "Bhavnagar",
    "Other Area"
  ],
  "Gujarat|Jamnagar": [
    "Jamnagar",
    "Other Area"
  ],
  "Gujarat|Gandhinagar": [
    "Gandhinagar",
    "Other Area"
  ],
  "Gujarat|Anand": [
    "Anand",
    "Other Area"
  ],
  "Gujarat|Kheda": [
    "Kheda",
    "Other Area"
  ],
  "Gujarat|Mehsana": [
    "Mehsana",
    "Other Area"
  ],
  "Punjab|Amritsar": [
    "Amritsar",
    "Other Area"
  ],
  "Punjab|Ludhiana": [
    "Ludhiana",
    "Other Area"
  ],
  "Punjab|Jalandhar": [
    "Jalandhar",
    "Other Area"
  ],
  "Punjab|Patiala": [
    "Patiala",
    "Other Area"
  ],
  "Punjab|Bathinda": [
    "Bathinda",
    "Other Area"
  ],
  "Punjab|Mohali": [
    "Mohali",
    "Other Area"
  ],
  "Punjab|Gurdaspur": [
    "Gurdaspur",
    "Other Area"
  ],
  "Punjab|Hoshiarpur": [
    "Hoshiarpur",
    "Other Area"
  ],
  "Uttar Pradesh|Lucknow": [
    "Lucknow",
    "Other Area"
  ],
  "Uttar Pradesh|Kanpur": [
    "Kanpur",
    "Other Area"
  ],
  "Uttar Pradesh|Agra": [
    "Agra",
    "Other Area"
  ],
  "Uttar Pradesh|Varanasi": [
    "Varanasi",
    "Other Area"
  ],
  "Uttar Pradesh|Prayagraj": [
    "Prayagraj",
    "Other Area"
  ],
  "Uttar Pradesh|Meerut": [
    "Meerut",
    "Other Area"
  ],
  "Uttar Pradesh|Ghaziabad": [
    "Ghaziabad",
    "Other Area"
  ],
  "Uttar Pradesh|Noida": [
    "Noida",
    "Other Area"
  ],
  "Uttar Pradesh|Gorakhpur": [
    "Gorakhpur",
    "Other Area"
  ],
  "Uttar Pradesh|Bareilly": [
    "Bareilly",
    "Other Area"
  ],
  "Madhya Pradesh|Bhopal": [
    "Bhopal",
    "Other Area"
  ],
  "Madhya Pradesh|Indore": [
    "Indore",
    "Other Area"
  ],
  "Madhya Pradesh|Gwalior": [
    "Gwalior",
    "Other Area"
  ],
  "Madhya Pradesh|Jabalpur": [
    "Jabalpur",
    "Other Area"
  ],
  "Madhya Pradesh|Ujjain": [
    "Ujjain",
    "Other Area"
  ],
  "Madhya Pradesh|Sagar": [
    "Sagar",
    "Other Area"
  ],
  "Madhya Pradesh|Rewa": [
    "Rewa",
    "Other Area"
  ],
  "Madhya Pradesh|Satna": [
    "Satna",
    "Other Area"
  ],
  "Bihar|Patna": [
    "Patna",
    "Other Area"
  ],
  "Bihar|Gaya": [
    "Gaya",
    "Other Area"
  ],
  "Bihar|Muzaffarpur": [
    "Muzaffarpur",
    "Other Area"
  ],
  "Bihar|Bhagalpur": [
    "Bhagalpur",
    "Other Area"
  ],
  "Bihar|Darbhanga": [
    "Darbhanga",
    "Other Area"
  ],
  "Bihar|Purnia": [
    "Purnia",
    "Other Area"
  ],
  "Jharkhand|Ranchi": [
    "Ranchi",
    "Other Area"
  ],
  "Jharkhand|Jamshedpur": [
    "Jamshedpur",
    "Other Area"
  ],
  "Jharkhand|Dhanbad": [
    "Dhanbad",
    "Other Area"
  ],
  "Jharkhand|Bokaro": [
    "Bokaro",
    "Other Area"
  ],
  "Jharkhand|Deoghar": [
    "Deoghar",
    "Other Area"
  ],
  "Chhattisgarh|Raipur": [
    "Raipur",
    "Other Area"
  ],
  "Chhattisgarh|Bilaspur": [
    "Bilaspur",
    "Other Area"
  ],
  "Chhattisgarh|Durg": [
    "Durg",
    "Other Area"
  ],
  "Chhattisgarh|Korba": [
    "Korba",
    "Other Area"
  ],
  "Chhattisgarh|Raigarh": [
    "Raigarh",
    "Other Area"
  ],
  "Goa|North Goa": [
    "North Goa",
    "Other Area"
  ],
  "Goa|South Goa": [
    "South Goa",
    "Other Area"
  ],
  "Assam|Kamrup Metropolitan": [
    "Kamrup Metropolitan",
    "Other Area"
  ],
  "Assam|Dibrugarh": [
    "Dibrugarh",
    "Other Area"
  ],
  "Assam|Jorhat": [
    "Jorhat",
    "Other Area"
  ],
  "Assam|Silchar": [
    "Silchar",
    "Other Area"
  ],
  "Assam|Tezpur": [
    "Tezpur",
    "Other Area"
  ],
  "Puducherry|Puducherry": [
    "Puducherry",
    "Other Area"
  ],
  "Puducherry|Karaikal": [
    "Karaikal",
    "Other Area"
  ],
  "Puducherry|Mahe": [
    "Mahe",
    "Other Area"
  ],
  "Puducherry|Yanam": [
    "Yanam",
    "Other Area"
  ],
  "Andaman and Nicobar Islands|General": [
    "Andaman and Nicobar Islands",
    "Other Area"
  ],
  "Arunachal Pradesh|General": [
    "Arunachal Pradesh",
    "Other Area"
  ],
  "Chandigarh|General": [
    "Chandigarh",
    "Other Area"
  ],
  "Dadra and Nagar Haveli and Daman and Diu|General": [
    "Dadra and Nagar Haveli and Daman and Diu",
    "Other Area"
  ],
  "Haryana|General": [
    "Haryana",
    "Other Area"
  ],
  "Himachal Pradesh|General": [
    "Himachal Pradesh",
    "Other Area"
  ],
  "Jammu and Kashmir|General": [
    "Jammu and Kashmir",
    "Other Area"
  ],
  "Ladakh|General": [
    "Ladakh",
    "Other Area"
  ],
  "Lakshadweep|General": [
    "Lakshadweep",
    "Other Area"
  ],
  "Manipur|General": [
    "Manipur",
    "Other Area"
  ],
  "Meghalaya|General": [
    "Meghalaya",
    "Other Area"
  ],
  "Mizoram|General": [
    "Mizoram",
    "Other Area"
  ],
  "Nagaland|General": [
    "Nagaland",
    "Other Area"
  ],
  "Sikkim|General": [
    "Sikkim",
    "Other Area"
  ],
  "Tripura|General": [
    "Tripura",
    "Other Area"
  ],
  "Uttarakhand|General": [
    "Uttarakhand",
    "Other Area"
  ]
};

export const LOCATIONS_BY_STATE = {
  "Andhra Pradesh": [
    "Addanki",
    "Addateegala",
    "Adoni",
    "Allagadda",
    "Allavaram",
    "Allur",
    "Amadalavalasa",
    "Amalapuram",
    "Amaravathi",
    "Ambajipeta",
    "Anakapalli",
    "Anandapuram",
    "Anantapur",
    "Ananthagiri",
    "Anaparthi",
    "Araku Valley",
    "Atmakur",
    "Atreyapuram",
    "Avanigadda",
    "Badvel",
    "Baireddipalle",
    "Banaganapalle",
    "Bangarupalem",
    "Bantumilli",
    "Bapatla",
    "Bethamcherla",
    "Bheemunipatnam",
    "Bhimavaram",
    "Bobbili",
    "Bollapalle",
    "Buchinaidu Khandriga",
    "Buchireddipalem",
    "Chandragiri",
    "Chebrolu",
    "Cheepurupalli",
    "Chillakur",
    "Chinnagottigallu",
    "Chinnamandem",
    "Chintalapudi",
    "Chintapalle",
    "Chinturu",
    "Chirala",
    "Chittoor",
    "Chitvel",
    "Chodavaram",
    "Cumbum",
    "Dachepalle",
    "Darsi",
    "Denduluru",
    "Devarapalle",
    "Devipatnam",
    "Dharmavaram",
    "Dhone",
    "Dornala",
    "Duggirala",
    "Dumbriguda",
    "Eluru",
    "G.Madugula",
    "Gajapathinagaram",
    "Gajuwaka",
    "Galiveedu",
    "Gangadhara Nellore",
    "Gangavaram",
    "Gannavaram",
    "Garugubilli",
    "Ghantasala",
    "Giddalur",
    "Gollaprolu",
    "Gooty",
    "Gorantla",
    "Gudimallam",
    "Gudipala",
    "Gudivada",
    "Gudupalle",
    "Gudur",
    "Guduru",
    "Guntakal",
    "Guntur",
    "Gurazala",
    "Hindupur",
    "Hukumpeta",
    "I.Polavaram",
    "Ibrahimpatnam",
    "Ichchapuram",
    "Indukurpet",
    "Inkollu",
    "Irala",
    "Jaggampeta",
    "Jaggayyapeta",
    "Jammalamadugu",
    "Jangareddygudem",
    "Kadapa",
    "Kadiri",
    "Kaikaluru",
    "Kakinada",
    "Kakumanu",
    "Kalikiri",
    "Kalyanadurgam",
    "Kamalapuram",
    "Kandukur",
    "Kanigiri",
    "Karlapalem",
    "Karvetinagaram",
    "Kasimkota",
    "Kavali",
    "Kirlampudi",
    "Kodavalur",
    "Kodumur",
    "Koilkuntla",
    "Komarada",
    "Konakanamitla",
    "Korlagunta",
    "Kota",
    "Kothacheruvu",
    "Kothapalle",
    "Kothapeta",
    "Kovur",
    "Kovvur",
    "Koyyuru",
    "Kunavaram",
    "Kuppam",
    "Kurnool",
    "Kurupam",
    "Lakkireddipalle",
    "Macherla",
    "Machilipatnam",
    "Madakasira",
    "Madanapalle",
    "Madugula",
    "Mahanandi",
    "Makkuva",
    "Malikipuram",
    "Mandapeta",
    "Mangalagiri",
    "Manubolu",
    "Maredumilli",
    "Markapur",
    "Martur",
    "Movva",
    "Mulakalacheruvu",
    "Mummidivaram",
    "Munchingiput",
    "Muppalla",
    "Muthukur",
    "Mydukur",
    "Mylavaram",
    "Nagari",
    "Naidupeta",
    "Nallamada",
    "Nandigama",
    "Nandikotkur",
    "Nandyal",
    "Narasannapeta",
    "Narasapuram",
    "Narasaraopet",
    "Narayanavanam",
    "Narsipatnam",
    "Nekarikallu",
    "Nellimarla",
    "Nellore",
    "Nidadavole",
    "Nindra",
    "Nizampatnam",
    "Nuzvid",
    "Obulavaripalle",
    "Ongole",
    "Orvakal",
    "Owk",
    "Pachipenta",
    "Paderu",
    "Padmanabham",
    "Pakala",
    "Palakollu",
    "Palakonda",
    "Palamaner",
    "Palasa",
    "Palasamudram",
    "Pamarru",
    "Pamidi",
    "Pamur",
    "Paravada",
    "Parchur",
    "Parigi",
    "Parvathipuram",
    "Pathapatnam",
    "Pattikonda",
    "Payakaraopeta",
    "Pedabayalu",
    "Pedakakani",
    "Pedana",
    "Pedavegi",
    "Peddamandyam",
    "Peddapanjani",
    "Peddapuram",
    "Penagalur",
    "Penamaluru",
    "Pendlimarri",
    "Pendurthi",
    "Penugonda",
    "Penukonda",
    "Penumur",
    "Pichatur",
    "Piduguralla",
    "Pileru",
    "Pithapuram",
    "Podili",
    "Ponnur",
    "Porumamilla",
    "Prathipadu",
    "Proddatur",
    "Pulivendla",
    "Pullalacheruvu",
    "Pullampeta",
    "Punganur",
    "Puthalapattu",
    "Puttaparthi",
    "Puttur",
    "Railway Koduru",
    "Rajahmundry",
    "Rajam",
    "Rajampet",
    "Rajavommangi",
    "Ramachandrapuram",
    "Ramapuram",
    "Ramasamudram",
    "Rambilli",
    "Rampachodavaram",
    "Rayachoti",
    "Rayadurg",
    "Razole",
    "Reddigudem",
    "Renigunta",
    "Renigunta Rural",
    "Repalle",
    "Rompicharla",
    "S.Rayavaram",
    "Sabbavaram",
    "Salur",
    "Samalkot",
    "Sambepalle",
    "Sanjamala",
    "Sankhavaram",
    "Santhipuram",
    "Sattenapalli",
    "Satyavedu",
    "Seethanagaram",
    "Sidhout",
    "Singarayakonda",
    "Sodam",
    "Somala",
    "Sompeta",
    "Srikakulam",
    "Srikalahasti",
    "Srungavarapukota",
    "Sullurpeta",
    "Sullurupeta",
    "Tada",
    "Tadepalle",
    "Tadepalligudem",
    "Tadikonda",
    "Tadipatri",
    "Tanguturu",
    "Tanuku",
    "Tavanampalle",
    "Tekkali",
    "Tenali",
    "Thamballapalle",
    "Thottambedu",
    "Thullur",
    "Tirupati",
    "Tirupati Rural",
    "Tiruvuru",
    "Tripuranthakam",
    "Tuni",
    "Undi",
    "Uravakonda",
    "Vadamalapeta",
    "Varadaiahpalem",
    "Vararamachandrapuram",
    "Vayalpad",
    "Vedurukuppam",
    "Velugodu",
    "Vempalle",
    "Venkatagiri",
    "Vidavalur",
    "Vijayawada",
    "Vinjamur",
    "Vinukonda",
    "Visakhapatnam",
    "Vizianagaram",
    "Vuyyuru",
    "Y.Ramavaram",
    "Yadamarri",
    "Yelamanchili",
    "Yeleswaram",
    "Yemmiganur",
    "Yerpedu",
    "Yerragondapalem"
  ],
  "Telangana": [
    "Adilabad",
    "Alwal",
    "Amberpet",
    "Ameerpet",
    "Armoor",
    "Asifnagar",
    "Bachupally",
    "Bahadurpura",
    "Balanagar",
    "Balkonda",
    "Bandlaguda",
    "Bhadradri Kothagudem",
    "Bheemgal",
    "Boath",
    "Charminar",
    "Chevella",
    "Chinnakodur",
    "Chityala",
    "Choppadandi",
    "Devarakonda",
    "Dharmasagar",
    "Dichpalle",
    "Dubbak",
    "Duggondi",
    "Eturnagaram",
    "Gadwal",
    "Gajwel",
    "Ghatkesar",
    "Golconda",
    "Hanamkonda",
    "Hasanparthy",
    "Himayathnagar",
    "Husnabad",
    "Huzurabad",
    "Ibrahimpatnam",
    "Ichoda",
    "Inavole",
    "Jagtial",
    "Jainoor",
    "Jakranpalle",
    "Jammikunta",
    "Jangaon",
    "Jayashankar Bhupalpally",
    "Jinnaram",
    "Jogulamba Gadwal",
    "Kallur",
    "Kamareddy",
    "Kandukur",
    "Kapra",
    "Karimnagar",
    "Kazipet",
    "Keesara",
    "Khairatabad",
    "Khammam",
    "Kodangal",
    "Kollapur",
    "Komuravelli",
    "Kondapur",
    "Kumuram Bheem Asifabad",
    "Mahabubabad",
    "Mahabubnagar",
    "Maheshwaram",
    "Malakpet",
    "Malkajgiri",
    "Manakondur",
    "Mancherial",
    "Marredpally",
    "Medak",
    "Medchal",
    "Miryalaguda",
    "Mogullapalle",
    "Moinabad",
    "Mudigonda",
    "Mulugu",
    "Musheerabad",
    "Nagarkurnool",
    "Nakrekal",
    "Nalgonda",
    "Nallabelly",
    "Nampally",
    "Narayanpet",
    "Narnoor",
    "Narsampet",
    "Narsapur",
    "Nelakondapalle",
    "Nidamanur",
    "Nirmal",
    "Nizamabad",
    "Other Area",
    "Parkal",
    "Patancheru",
    "Peddapalli",
    "Quthbullapur",
    "Rajanna Sircilla",
    "Rajendranagar",
    "Ramachandrapuram",
    "Ramayampet",
    "Sadasivpet",
    "Saidapur",
    "Sangareddy",
    "Sathupally",
    "Secunderabad",
    "Serilingampally",
    "Shabad",
    "Shaikpet",
    "Shamshabad",
    "Shankarampet",
    "Shankarpalle",
    "Siddipet",
    "Suryapet",
    "Tekmal",
    "Tirumalgiri",
    "Toopran",
    "Uppal",
    "Utnoor",
    "Velair",
    "Vikarabad",
    "Wanaparthy",
    "Warangal",
    "Wardhannapet",
    "Wyra",
    "Yacharam",
    "Yadadri Bhuvanagiri"
  ],
  "Karnataka": [
    "Bagalkot",
    "Ballari",
    "Bangalore Rural",
    "Bangalore Urban",
    "Belagavi",
    "Bidar",
    "Chamarajanagar",
    "Chikkaballapur",
    "Chikkamagaluru",
    "Chitradurga",
    "Dakshina Kannada",
    "Davanagere",
    "Gadag",
    "Hassan",
    "Haveri",
    "Hubballi-Dharwad",
    "Kalaburagi",
    "Kodagu",
    "Kolar",
    "Koppal",
    "Mandya",
    "Mangaluru",
    "Mysuru",
    "Other Area",
    "Raichur",
    "Ramanagara",
    "Shivamogga",
    "Tumakuru",
    "Udupi",
    "Uttara Kannada",
    "Vijayapura",
    "Yadgir"
  ],
  "Tamil Nadu": [
    "Ariyalur",
    "Chengalpattu",
    "Chennai",
    "Coimbatore",
    "Cuddalore",
    "Dharmapuri",
    "Dindigul",
    "Erode",
    "Kallakurichi",
    "Kanchipuram",
    "Karur",
    "Krishnagiri",
    "Madurai",
    "Mayiladuthurai",
    "Nagapattinam",
    "Namakkal",
    "Nilgiris",
    "Other Area",
    "Perambalur",
    "Pudukkottai",
    "Ramanathapuram",
    "Ranipet",
    "Salem",
    "Sivaganga",
    "Tenkasi",
    "Thanjavur",
    "Theni",
    "Thoothukudi",
    "Tiruchirappalli",
    "Tirunelveli",
    "Tirupattur",
    "Tiruppur",
    "Tiruvallur",
    "Vellore",
    "Virudhunagar"
  ],
  "Maharashtra": [
    "Ahmednagar",
    "Akola",
    "Amravati",
    "Aurangabad",
    "Beed",
    "Bhandara",
    "Buldhana",
    "Chandrapur",
    "Dhule",
    "Gadchiroli",
    "Gondia",
    "Hingoli",
    "Jalgaon",
    "Jalna",
    "Kolhapur",
    "Latur",
    "Mumbai",
    "Nagpur",
    "Nanded",
    "Nandurbar",
    "Nashik",
    "Osmanabad",
    "Other Area",
    "Palghar",
    "Parbhani",
    "Pune",
    "Raigad",
    "Ratnagiri",
    "Sangli",
    "Satara",
    "Sindhudurg",
    "Solapur",
    "Thane",
    "Wardha",
    "Washim",
    "Yavatmal"
  ],
  "Kerala": [
    "Alappuzha",
    "Ernakulam",
    "Idukki",
    "Kannur",
    "Kasaragod",
    "Kollam",
    "Kottayam",
    "Kozhikode",
    "Malappuram",
    "Other Area",
    "Palakkad",
    "Pathanamthitta",
    "Thiruvananthapuram",
    "Thrissur",
    "Wayanad"
  ],
  "Delhi": [
    "Central Delhi",
    "East Delhi",
    "New Delhi",
    "North Delhi",
    "North East Delhi",
    "North West Delhi",
    "Other Area",
    "Shahdara",
    "South Delhi",
    "South East Delhi",
    "South West Delhi",
    "West Delhi"
  ],
  "Odisha": [
    "Balasore",
    "Cuttack",
    "Ganjam",
    "Jajpur",
    "Khordha",
    "Koraput",
    "Mayurbhanj",
    "Other Area",
    "Puri",
    "Sambalpur",
    "Sundargarh"
  ],
  "West Bengal": [
    "Bardhaman",
    "Darjeeling",
    "Hooghly",
    "Howrah",
    "Kolkata",
    "Murshidabad",
    "Nadia",
    "North 24 Parganas",
    "Other Area",
    "Siliguri",
    "South 24 Parganas"
  ],
  "Rajasthan": [
    "Ajmer",
    "Alwar",
    "Bharatpur",
    "Bikaner",
    "Jaipur",
    "Jodhpur",
    "Kota",
    "Other Area",
    "Pali",
    "Sikar",
    "Udaipur"
  ],
  "Gujarat": [
    "Ahmedabad",
    "Anand",
    "Bhavnagar",
    "Gandhinagar",
    "Jamnagar",
    "Kheda",
    "Mehsana",
    "Other Area",
    "Rajkot",
    "Surat",
    "Vadodara"
  ],
  "Punjab": [
    "Amritsar",
    "Bathinda",
    "Gurdaspur",
    "Hoshiarpur",
    "Jalandhar",
    "Ludhiana",
    "Mohali",
    "Other Area",
    "Patiala"
  ],
  "Uttar Pradesh": [
    "Agra",
    "Bareilly",
    "Ghaziabad",
    "Gorakhpur",
    "Kanpur",
    "Lucknow",
    "Meerut",
    "Noida",
    "Other Area",
    "Prayagraj",
    "Varanasi"
  ],
  "Madhya Pradesh": [
    "Bhopal",
    "Gwalior",
    "Indore",
    "Jabalpur",
    "Other Area",
    "Rewa",
    "Sagar",
    "Satna",
    "Ujjain"
  ],
  "Bihar": [
    "Bhagalpur",
    "Darbhanga",
    "Gaya",
    "Muzaffarpur",
    "Other Area",
    "Patna",
    "Purnia"
  ],
  "Jharkhand": [
    "Bokaro",
    "Deoghar",
    "Dhanbad",
    "Jamshedpur",
    "Other Area",
    "Ranchi"
  ],
  "Chhattisgarh": [
    "Bilaspur",
    "Durg",
    "Korba",
    "Other Area",
    "Raigarh",
    "Raipur"
  ],
  "Goa": [
    "North Goa",
    "Other Area",
    "South Goa"
  ],
  "Assam": [
    "Dibrugarh",
    "Jorhat",
    "Kamrup Metropolitan",
    "Other Area",
    "Silchar",
    "Tezpur"
  ],
  "Puducherry": [
    "Karaikal",
    "Mahe",
    "Other Area",
    "Puducherry",
    "Yanam"
  ],
  "Andaman and Nicobar Islands": [
    "Andaman and Nicobar Islands",
    "Other Area"
  ],
  "Arunachal Pradesh": [
    "Arunachal Pradesh",
    "Other Area"
  ],
  "Chandigarh": [
    "Chandigarh",
    "Other Area"
  ],
  "Dadra and Nagar Haveli and Daman and Diu": [
    "Dadra and Nagar Haveli and Daman and Diu",
    "Other Area"
  ],
  "Haryana": [
    "Haryana",
    "Other Area"
  ],
  "Himachal Pradesh": [
    "Himachal Pradesh",
    "Other Area"
  ],
  "Jammu and Kashmir": [
    "Jammu and Kashmir",
    "Other Area"
  ],
  "Ladakh": [
    "Ladakh",
    "Other Area"
  ],
  "Lakshadweep": [
    "Lakshadweep",
    "Other Area"
  ],
  "Manipur": [
    "Manipur",
    "Other Area"
  ],
  "Meghalaya": [
    "Meghalaya",
    "Other Area"
  ],
  "Mizoram": [
    "Mizoram",
    "Other Area"
  ],
  "Nagaland": [
    "Nagaland",
    "Other Area"
  ],
  "Sikkim": [
    "Other Area",
    "Sikkim"
  ],
  "Tripura": [
    "Other Area",
    "Tripura"
  ],
  "Uttarakhand": [
    "Other Area",
    "Uttarakhand"
  ]
};

/** @deprecated use MANDALS_BY_STATE_DISTRICT — kept for compat */
export const CITIES_BY_STATE_DISTRICT = MANDALS_BY_STATE_DISTRICT;

export const POPULAR_CITIES = [
  "Hyderabad",
  "Bangalore",
  "Bengaluru",
  "Chennai",
  "Mumbai",
  "Delhi",
  "Kolkata",
  "Pune",
  "Vijayawada",
  "Tirupati",
  "Visakhapatnam",
  "Amaravathi",
  "Guntur",
  "Nellore",
  "Warangal",
  "Nizamabad",
  "Kadapa",
  "Kurnool"
];

export function slugPart(s) {
  return String(s || '').toLowerCase().trim().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '');
}

/** Stable ID: state--district--mandal */
export function makeCityCode(state, district, mandal) {
  return slugPart(state) + '--' + slugPart(district) + '--' + slugPart(mandal);
}

export function districtsForState(state) {
  return DISTRICTS_BY_STATE[state] || [];
}

export function mandalsForDistrict(state, district) {
  const key = state + '|' + district;
  if (MANDALS_BY_STATE_DISTRICT[key]?.length) return MANDALS_BY_STATE_DISTRICT[key];
  return LOCATIONS_BY_STATE[state] || [];
}

/** Alias */
export function citiesForDistrict(state, district) {
  return mandalsForDistrict(state, district);
}

export function allPickerCities() {
  const set = new Set(POPULAR_CITIES);
  Object.values(LOCATIONS_BY_STATE).forEach((arr) => arr.forEach((c) => set.add(c)));
  return [...set].sort((a, b) => a.localeCompare(b, undefined, { sensitivity: 'base' }));
}

export function resolveSelection(state, district, mandal, locality) {
  return {
    state: state || '',
    district: district || '',
    city: mandal || '',
    mandal: mandal || '',
    locality: locality || '',
    cityCode: state && mandal ? makeCityCode(state, district, mandal) : '',
  };
}

/** Find district for a mandal name within a state (patient picker validation). */
export function findDistrictForMandal(state, mandalName) {
  if (!state || !mandalName) return null;
  const districts = DISTRICTS_BY_STATE[state] || [];
  const lower = mandalName.toLowerCase();
  for (const d of districts) {
    const mandals = mandalsForDistrict(state, d);
    if (mandals.some((m) => m.toLowerCase() === lower)) return d;
  }
  return null;
}
